import React from "react";
import { resolveMediaUrl } from "@/lib/api";

/**
 * MSJ typographic monogram.
 * If admin has uploaded a real logo (settings.logo_url) we render that image.
 * Otherwise we render a metallic wordmark using the Anton font.
 */
export default function Logo({ logoUrl, size = "md", className = "", testId }) {
  const sizeMap = {
    sm: "text-2xl md:text-3xl",
    md: "text-4xl md:text-5xl",
    lg: "text-6xl md:text-8xl",
    xl: "text-8xl md:text-9xl",
  };

  const imgSize = {
    sm: "h-8 md:h-10",
    md: "h-12 md:h-14",
    lg: "h-24 md:h-32",
    xl: "h-32 md:h-44",
  };

  if (logoUrl) {
    return (
      <img
        src={resolveMediaUrl(logoUrl)}
        alt="MSJ Car Detailing & Pressure Washing"
        className={`${imgSize[size]} w-auto object-contain ${className}`}
        data-testid={testId}
      />
    );
  }

  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-2 ${className}`}
    >
      <span
        className={`font-anton ${sizeMap[size]} leading-none tracking-tighter uppercase bg-clip-text text-transparent bg-gradient-to-br from-white via-zinc-300 to-zinc-500`}
      >
        MSJ
      </span>
      <span
        className={`hidden sm:inline-block h-6 md:h-8 w-px bg-white/20 ${size === "lg" || size === "xl" ? "h-12" : ""}`}
      />
      <span
        className={`hidden sm:flex flex-col leading-tight text-[10px] md:text-xs uppercase tracking-[0.25em] text-zinc-400 font-medium`}
      >
        <span>Car Detailing</span>
        <span className="text-cyan-400/80">&amp; Pressure Wash</span>
      </span>
    </span>
  );
}
